export default function MensClothingIcon() {
  return (
    <svg viewBox="0 0 187 187" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="93.0627" cy="93.0627" r="93.0627" fill="url(#MensClothingIconGradientFilter)" />
      <path fillRule="evenodd" clipRule="evenodd" d="M117.139 42.0894L152.883 71.4691C153.262 71.7813 133.858 86.6057 131.51 85.5716C129.934 84.8773 126.782 83.4893 125.207 82.795C121.24 81.0481 127.427 137.267 124.458 143.739C124.275 144.136 61.8514 144.136 61.6677 143.739C58.6994 137.267 64.8861 81.0481 60.9193 82.795C59.3433 83.4893 56.1919 84.8773 54.6159 85.5716C52.2675 86.6057 32.8631 71.7813 33.2422 71.4691L68.9862 42.0894H84.3132C79.1385 56.0868 108.66 56.0868 103.485 42.0894H117.139Z" fill="url(#MensClothingIconClothFilter)" />
      <defs>
        <linearGradient id="MensClothingIconGradientFilter" x1="93.0627" y1="0" x2="93.0627" y2="186.125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFF48C" />
          <stop offset="1" stopColor="#FFE600" stopOpacity="0.25" />
        </linearGradient>
        <linearGradient id="MensClothingIconClothFilter" x1="93.0628" y1="42.0894" x2="93.0628" y2="144.036" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF8181" />
          <stop offset="1" stopColor="#FFF59B" stopOpacity="0.62" />
        </linearGradient>
      </defs>
    </svg>

  );
}
